import { memo } from 'react';

const NoResult = () => (
  <svg
    width="197"
    height="172"
    viewBox="0 0 197 172"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M98.5057 160.404C141.631 160.404 176.605 125.694 176.605 82.8311C176.605 39.9686 141.631 5.25781 98.5057 5.25781C55.3802 5.25781 20.4065 39.9686 20.4065 82.8311C20.4065 125.694 55.3802 160.404 98.5057 160.404Z"
      fill="#EAEEF9"
    />
    <path
      d="M158.329 72.7065V120.171C158.329 130.032 150.309 138.052 140.317 138.052H56.9581C47.0971 138.052 39.0768 130.163 38.9453 120.302C38.9453 120.171 38.9453 120.171 38.9453 120.039V72.7065C38.9453 72.575 38.9453 72.575 38.9453 72.4436C38.9453 72.1806 38.9453 71.9176 39.0768 71.6547C39.2083 71.2602 39.3398 70.9973 39.4712 70.6028L61.8229 27.8718C62.6117 26.1625 64.321 25.2422 66.1617 25.2422H130.981C132.822 25.2422 134.4 26.1625 135.32 27.8718L157.672 70.6028C157.803 70.8658 157.935 71.2602 158.066 71.6547C158.329 71.9176 158.329 72.3121 158.329 72.7065Z"
      fill="url(#paint0_linear_89_87347)"
    />
    <g filter="url(#filter0_d_89_87347)">
      <path
        d="M115.73 73.1001H81.9392C80.4929 73.1001 79.3096 72.0483 79.3096 70.4705V24.321C79.3096 22.8747 80.3614 21.6914 81.9392 21.6914H115.598C117.044 21.6914 118.228 22.7432 118.228 24.321V70.4705C118.228 71.9168 117.176 73.1001 115.73 73.1001Z"
        fill="#F5F8FF"
      />
    </g>
    <g filter="url(#filter1_d_89_87347)">
      <path
        d="M126.905 84.0142H70.7633C68.9226 84.0142 67.4763 82.4364 67.4763 80.7272V35.8925C67.4763 34.0518 69.0541 32.6055 70.7633 32.6055H126.905C128.746 32.6055 130.192 34.1832 130.192 35.8925V80.7272C130.061 82.5679 128.746 84.0142 126.905 84.0142Z"
        fill="#F5F8FF"
      />
    </g>
    <g filter="url(#filter2_d_89_87347)">
      <path
        d="M133.348 96.7694H64.4524C62.4802 96.7694 60.771 95.0602 60.771 93.2195V49.0422C60.771 47.0699 62.4802 45.4922 64.4524 45.4922H133.348C135.32 45.4922 137.029 47.2014 137.029 49.0422V93.088C136.898 95.1917 135.32 96.7694 133.348 96.7694Z"
        fill="#F5F8FF"
      />
    </g>
    <g filter="url(#filter3_d_89_87347)">
      <path
        d="M140.316 109.126H57.484C55.2488 109.126 53.5396 107.286 53.5396 105.313V61.7934C53.5396 59.5582 55.3803 57.9805 57.484 57.9805H140.316C142.552 57.9805 144.261 59.8212 144.261 61.7934V105.182C144.129 107.417 142.552 109.126 140.316 109.126Z"
        fill="#F5F8FF"
      />
    </g>
    <path
      d="M115.467 75.2063H84.3058C83.5169 75.2063 82.728 74.5489 82.728 73.6285C82.728 72.8397 83.3854 72.0508 84.3058 72.0508H115.467C116.255 72.0508 117.044 72.7082 117.044 73.6285C117.044 74.5489 116.387 75.2063 115.467 75.2063Z"
      fill="#E6ECF5"
    />
    <path
      d="M106.395 84.411H66.9506C66.4247 84.411 66.0303 84.0166 66.0303 83.4907C66.0303 82.9648 66.4247 82.5703 66.9506 82.5703H106.263C106.789 82.5703 107.184 82.9648 107.184 83.4907C107.447 83.7536 107.052 84.411 106.395 84.411Z"
      fill="#E6ECF5"
    />
    <path
      d="M132.296 84.411H112.443C111.917 84.411 111.522 84.0166 111.522 83.4907C111.522 82.9648 111.917 82.5703 112.443 82.5703H132.165C132.691 82.5703 133.085 82.9648 133.085 83.4907C133.348 83.7536 132.953 84.411 132.296 84.411Z"
      fill="#E6ECF5"
    />
    <g filter="url(#filter4_d_89_87347)">
      <path
        d="M151.469 75.0872V120.088C151.469 126.488 146.349 131.608 139.832 131.608H57.4422C51.0418 131.608 45.8052 126.488 45.8052 120.088V74.8545C45.8052 74.6217 45.8052 74.389 45.9215 74.1562H68.5095C72.466 74.1562 75.7244 77.2982 75.7244 81.3712C75.7244 83.3495 76.539 85.2114 77.819 86.4914C79.2155 87.8879 80.8447 88.5861 82.9393 88.5861H115.766C119.723 88.5861 122.981 85.4441 122.981 81.3712C122.981 79.3929 123.795 77.531 125.076 76.2509C126.472 74.8545 128.101 74.1562 130.079 74.1562H151.236C151.469 74.389 151.469 74.7381 151.469 75.0872Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter5_d_89_87347)">
      <path
        d="M158.329 72.7081V125.037C158.329 132.269 152.544 138.054 145.181 138.054H52.0931C44.8617 138.054 38.9451 132.269 38.9451 125.037V72.4451C38.9451 72.1822 38.9451 71.9192 39.0765 71.6562H69.054C73.5243 71.6562 77.2058 75.2062 77.2058 79.808C77.2058 82.0432 78.1262 84.1469 79.5724 85.5931C81.1502 87.1709 82.9909 87.9598 85.3576 87.9598H112.048C116.518 87.9598 120.2 84.4098 120.2 79.808C120.2 77.5729 121.12 75.4692 122.566 74.0229C124.144 72.4451 125.985 71.6562 128.22 71.6562H158.066C158.329 71.9192 158.329 72.3136 158.329 72.7081Z"
        fill="url(#paint1_linear_89_87347)"
      />
    </g>
    <path
      d="M145.181 119.118H118.096C117.176 119.118 116.387 118.46 116.387 117.408C116.387 116.488 117.044 115.699 118.096 115.699H144.918C145.839 115.699 146.627 116.357 146.627 117.408C146.759 118.197 145.97 119.118 145.181 119.118Z"
      fill="#E6ECF5"
    />
    <path
      d="M133.085 127.403H118.096C117.176 127.403 116.387 126.745 116.387 125.694C116.387 124.773 117.044 123.984 118.096 123.984H132.953C133.874 123.984 134.663 124.642 134.663 125.694C134.794 126.482 134.005 127.403 133.085 127.403Z"
      fill="#E6ECF5"
    />
    <path
      d="M174.609 45.754C177.587 45.754 180 43.3405 180 40.3633C180 37.3861 177.587 34.9727 174.609 34.9727C171.632 34.9727 169.219 37.3861 169.219 40.3633C169.219 43.3405 171.632 45.754 174.609 45.754Z"
      fill="#EAEEF9"
    />
    <path
      d="M169.219 28.2652C171.252 28.2652 172.9 26.617 172.9 24.5838C172.9 22.5506 171.252 20.9023 169.219 20.9023C167.185 20.9023 165.537 22.5506 165.537 24.5838C165.537 26.617 167.185 28.2652 169.219 28.2652Z"
      fill="#EAEEF9"
    />
    <path
      d="M20.1204 40.3629C22.1536 40.3629 23.8019 38.7146 23.8019 36.6814C23.8019 34.6482 22.1536 33 20.1204 33C18.0872 33 16.439 34.6482 16.439 36.6814C16.439 38.7146 18.0872 40.3629 20.1204 40.3629Z"
      fill="#EAEEF9"
    />
    <path
      d="M11.837 121.354C15.6129 121.354 18.6739 118.293 18.6739 114.517C18.6739 110.741 15.6129 107.68 11.837 107.68C8.06101 107.68 5 110.741 5 114.517C5 118.293 8.06101 121.354 11.837 121.354Z"
      fill="#EAEEF9"
    />
    <defs>
      <filter
        id="filter0_d_89_87347"
        x="57.3096"
        y="0.691406"
        width="82.9181"
        height="95.4102"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_89_87347"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_89_87347"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_89_87347"
        x="45.4763"
        y="11.6055"
        width="106.716"
        height="95.4102"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_89_87347"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_89_87347"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_89_87347"
        x="38.771"
        y="24.4922"
        width="120.258"
        height="95.2773"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_89_87347"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_89_87347"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_89_87347"
        x="31.5396"
        y="36.9805"
        width="134.721"
        height="95.1445"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.18 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_89_87347"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_89_87347"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_89_87347"
        x="32.8052"
        y="58.1562"
        width="131.664"
        height="83.4531"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-3" />
        <feGaussianBlur stdDeviation="6.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_89_87347"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_89_87347"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_89_87347"
        x="16.9451"
        y="60.6562"
        width="163.384"
        height="110.398"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_89_87347"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_89_87347"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_89_87347"
        x1="98.6467"
        y1="29.1611"
        x2="98.6467"
        y2="92.4802"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#B0BACC" />
        <stop offset="1" stopColor="#969EAE" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_89_87347"
        x1="98.5981"
        y1="70.1204"
        x2="98.5981"
        y2="138.77"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FDFEFF" />
        <stop offset="0.9964" stopColor="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
);

const NoResultIcon = memo(NoResult);
export default NoResultIcon;
